// @ts-nocheck
// API client for the create-claim-from-PDF flow (PRD Phase 3).
// Mirrors the claimActionsApi convention: import the shared axios instance,
// unwrap `data`, return it.
import api from '../utils/axios';

/**
 * Upload a CMS-1500 / EOB PDF for claim import (no patient required up front).
 * @param {File} file
 * @param {'cms1500'|'eob'} documentKind
 * @returns {Promise<{extraction_id: string, status: string, document_kind: string, original_filename: string}>}
 */
export async function uploadClaimImport(file, documentKind = 'cms1500') {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('document_kind', documentKind);
  const { data } = await api.post('/documents/claim-import/uploads/', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

/**
 * Poll an extraction's status. On terminal (success/needs_review) the response
 * carries `extracted_data` + the validator's missing/low-confidence lists.
 * @param {string} extractionId
 */
export async function getClaimImportStatus(extractionId) {
  const { data } = await api.get(`/documents/claim-import/${extractionId}/status/`);
  return data;
}

/**
 * Commit the reviewed extraction into an editable Claim draft (create), or
 * attach an EOB's adjudication onto an existing claim (attach).
 *
 * - create mode (default): pass { confirmed, patient_link, provider_link }.
 * - attach mode (EOB only): pass { mode: 'attach', target_claim_id, confirmed }.
 *   The attach path skips patient/provider resolve (the target already has them).
 *
 * @param {string} extractionId
 * @param {{mode?: 'create'|'attach', confirmed: object, patient_link?: object, provider_link?: object, target_claim_id?: string}} body
 * @returns {Promise<{claim_id: string, validation?: object, idempotent?: boolean, attached?: boolean}>}
 */
export async function commitClaimImport(
  extractionId,
  { mode = 'create', confirmed, patient_link, provider_link, target_claim_id } = {},
) {
  const payload = mode === 'attach'
    ? { mode, target_claim_id, confirmed }
    : { confirmed, patient_link, provider_link };
  const { data } = await api.post(`/documents/claim-import/${extractionId}/commit/`, payload);
  return data;
}
